import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { API, SERVER_DOMAIN } from "../../assets/staticData";
import { toast } from "react-toastify";
import KeywordInput from "../keyword-input/KeywordInput";
import TextEditor from "../rich-text/TextEditor/TextEditor";
import { createSlug } from "../../utils/slug";

let userToken = localStorage.getItem("userToken");

export default function EditArticle({ itemToEdit, setItemToEdit, endpoint, refresh, setRefresh }) {
  const [input, setInput] = useState({});
  const [image, setImage] = useState(null);
  const [keywords, setKeywords] = useState([]);
  const [userInfo, setuserInfo] = useState();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  const fileInputRef = useRef();

  const ref = useRef();

  useEffect(() => {
    async function fetchData() {
      if (Object.keys(itemToEdit).length > 0) {
        try {
          const response = await fetch(`${API}/${endpoint}/${itemToEdit.id}?populate=*`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userToken}`,
            },
            method: "GET",
          });
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          const res = await response.json();
          setInput(res.data.attributes);
          setKeywords(res.data.attributes?.keywords);
          setSelectedUser(res.data?.attributes?.users_permissions_user?.data?.id);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }

    async function getUsers() {
      fetch(`${API}/users`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        method: "GET",
      }).then(async (res) => {
        const response = await res.json();
        setUsers(response);
      });
    }

    async function getUser() {
      fetch(`${API}/users/me?populate=*`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setuserInfo(respone);
      });
    }

    fetchData();
    getUser();
    getUsers();
  }, [itemToEdit]);

  const handleInputChange = (field, value) => {
    setInput({
      ...input,
      [field]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
    }
  };

  const automateSlug = (title) => {
    const slug = createSlug(title);

    setInput({
      ...input,
      slug,
    });
  };

  const saveChanges = () => {
    const updatedData = { ...input, keywords, users_permissions_user: selectedUser };

    if (image && image instanceof File) {
      const formData = new FormData();

      formData.append("files.image", image);
      formData.append("data", JSON.stringify(updatedData));

      fetch(`${API}/${endpoint}/${itemToEdit.id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      })
        .then(async (res) => {
          if (res.ok) {
            handleSuccess();
          } else {
            handleError(await res.json());
          }
        })
        .catch(handleError);
    } else {
      fetch(`${API}/${endpoint}/${itemToEdit.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: {
            title: input.title,
            slug: createSlug(input.slug),
            content: input.content,
            styles: input.styles,
            subTitle: input.subTitle,
            keywords: keywords,
            summary: input.summary || "",
            authorOpinion: input.authorOpinion || "",
            metaTitle: input.metaTitle,
            metaDesc: input.metaDesc,
            socialTitle: input.socialTitle,
            socialDesc: input.socialDesc,
            metaKeywords: input.metaKeywords,
            schema: input.schema,
            users_permissions_user: selectedUser,
          },
        }),
      })
        .then(async (res) => {
          if (res.ok) {
            handleSuccess();
          } else {
            handleError(await res.json());
          }
        })
        .catch(handleError);
    }
  };

  const handleSuccess = () => {
    setRefresh(!refresh);
    setItemToEdit({});
    setInput(null);
    setImage(null);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    toast("Updated Successfully", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      type: "success",
    });
  };

  const handleError = (error) => {
    console.error("Error updating entry:", error);
    toast("Error updating entry", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      type: "error",
    });
  };

  return (
    <div
      style={{
        backgroundColor: "#00000030",
        position: "fixed",
        width: "100vw",
        height: "100vh",
        zIndex: 999,
        top: 0,
        left: 0,
        opacity: Object.keys(itemToEdit).length > 0 ? 1 : 0,
        visibility: Object.keys(itemToEdit).length > 0 ? "visible" : "hidden",
        transition: "0.3s",
      }}
      className="flex">
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "fixed",
          zIndex: 9999,
        }}
        onClick={() => {
          setItemToEdit({});
          setInput(null);
        }}></div>
      <div
        ref={ref}
        style={{
          width: "70%",
          minWidth: 880,
          minheight: 560,
          height: "80vh",
          backgroundColor: "#fff",
          borderRadius: 15,
          transition: "0.3s",
          padding: 15,
          overflowY: "scroll",
          zIndex: 99999,
        }}>
        {input && (
          <div
            className="fadeInFast"
            style={{
              marginTop: 10,
              marginBottom: 20,
              display: "flex",
              flexDirection: "column",
              width: "100%",
              alignItems: "center",
            }}>
            <div style={{ width: "100%", display: "flex", marginBottom: 10 }}>
              <div style={{ width: "50%", height: "100%" }}>
                <TextField
                  label="Title"
                  sx={{ width: "90%" }}
                  id="title"
                  size="small"
                  value={input.title}
                  onChange={(e) => handleInputChange("title", e.target.value)}
                />
                <TextField
                  label="Slug"
                  sx={{ width: "90%", mt: 2 }}
                  id="slug"
                  size="small"
                  value={input.slug}
                  onChange={(e) => handleInputChange("slug", e.target.value)}
                />
                <div className="mt-1 mr-6 cursor-pointer" onClick={() => automateSlug(input.title)}>
                  <p className="text-sm text-right text-sky-700 underline">Automate Slug</p>
                </div>
                <TextField
                  label="Subtitle"
                  id="subtitle"
                  sx={{ width: "90%", mt: 2, mb: 2 }}
                  size="small"
                  multiline
                  rows={9}
                  value={input.subTitle}
                  onChange={(e) => handleInputChange("subTitle", e.target.value)}
                />
              </div>
              <div
                style={{
                  width: "50%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 10,
                }}>
                <div
                  style={{
                    border: "dashed",
                    borderWidth: 1,
                    borderColor: "grey",
                    height: 135,
                    marginTop: 1,
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "center",
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                  onClick={() => fileInputRef.current.click()}>
                  {image ? (
                    <img
                      src={URL.createObjectURL(image)}
                      style={{
                        width: 55,
                        aspectRatio: 1,
                        borderRadius: 55,
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img
                      src={
                        input.image
                          ? SERVER_DOMAIN + input.image?.data?.attributes?.url
                          : require("../../assets/icons/add-image.png")
                      }
                      style={{
                        width: 55,
                        aspectRatio: 1,
                        borderRadius: 55,
                        objectFit: "cover",
                      }}
                    />
                  )}
                  <p style={{ color: "#888", fontSize: 13, marginTop: 5 }}>
                    Click here to add an image
                  </p>
                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={handleImageChange}
                    ref={fileInputRef}
                    style={{ display: "none" }}
                  />
                </div>
                <KeywordInput keywords={keywords} setKeywords={setKeywords} />

                {(userInfo?.id === 40 || userInfo?.id === 36) && (
                  <FormControl sx={{ width: "90%", mt: 2 }}>
                    <InputLabel id="author-select-label">Select Author</InputLabel>
                    <Select
                      labelId="author-select-label"
                      id="author-select"
                      value={selectedUser}
                      label="Select Author"
                      onChange={(e) => {
                        setSelectedUser(e.target.value);
                      }}>
                      {users.map((user) => (
                        <MenuItem key={user.id} value={user.id}>
                          {user.username}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </div>
            </div>

            <div
              className="mt-4"
              style={{
                width: "100%",
              }}>
              <TextEditor
                init={{ min_height: 800 }}
                value={input.content}
                onChange={(val) => handleInputChange("content", val)}
              />
              {/* <ContentEditor
                token={userToken}
                onChange={handleContentEditorOnChange}
                value={{
                  elements: input.content,
                  styles: input.styles
                }} /> */}
            </div>

            {endpoint !== "analyses" && (
              <div
                className="flex"
                style={{
                  width: "100%",
                  marginTop: 10,
                  justifyContent: "space-between",
                }}>
                <TextField
                  label="Summary"
                  sx={{ width: "47%", mt: 2, mb: 2 }}
                  size="small"
                  multiline
                  rows={5}
                  value={input.summary || ""}
                  onChange={(e) => handleInputChange("summary", e.target.value)}
                />
                <TextField
                  label="Author's Opinion"
                  sx={{ width: "47%", mt: 2, mb: 2 }}
                  size="small"
                  multiline
                  rows={5}
                  value={input.authorOpinion || ""}
                  onChange={(e) => handleInputChange("authorOpinion", e.target.value)}
                />
              </div>
            )}

            <h3 style={{ alignSelf: "flex-start", marginTop: 10 }}>SEO Configuration</h3>
            <div
              className="flex"
              style={{
                width: "100%",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}>
              <TextField
                label="Meta Title"
                sx={{ width: "48%", mt: 2, mb: 2 }}
                value={input.metaTitle}
                onChange={(e) => handleInputChange("metaTitle", e.target.value)}
              />
              <TextField
                label="Social Title"
                sx={{ width: "48%", mt: 1, mb: 2 }}
                value={input.socialTitle}
                onChange={(e) => handleInputChange("socialTitle", e.target.value)}
              />
              <TextField
                label="Meta Description"
                sx={{ width: "48%", mt: 2, mb: 2 }}
                size="small"
                multiline
                rows={3}
                value={input.metaDesc}
                onChange={(e) => handleInputChange("metaDesc", e.target.value)}
              />
              <TextField
                label="Social Description"
                sx={{ width: "48%", mt: 1, mb: 2 }}
                size="small"
                multiline
                rows={3}
                value={input.socialDesc}
                onChange={(e) => handleInputChange("socialDesc", e.target.value)}
              />
              <div style={{ width: "48%", marginTop: 17 }}>
                <TextField
                  label="Meta Keyowrds"
                  sx={{ width: "100%" }}
                  size="small"
                  multiline
                  rows={4}
                  value={input.metaKeywords}
                  onChange={(e) => handleInputChange("metaKeywords", e.target.value)}
                />
                <p style={{ fontSize: 13, marginTop: 3, textAlign: "left" }}>
                  Seperate each Keyword by a ","
                </p>
              </div>
              <TextField
                label="Schema"
                sx={{ width: "48%", mt: 1, mb: 2 }}
                size="small"
                multiline
                rows={4}
                value={input.schema}
                onChange={(e) => handleInputChange("schema", e.target.value)}
              />
            </div>
          </div>
        )}
        <div className="submitBTN" style={{ margin: "0 auto", marginTop: 0 }} onClick={saveChanges}>
          Save Changes
        </div>
      </div>
    </div>
  );
}
